// Accepts emails, full URLs (http/https), and domain-only URLs (e.g., example.com)
const domainRegex = /^(?!.*\.\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}(\/.*)?$/;

export const isValidUrlFormat = (url: string): boolean => {
  // Reject empty string, or strings longer than 256 characters
  if (!url || typeof url !== 'string' || url.trim() === '' || url.length > 256) return false;

  return domainRegex.test(url);
};

export const validateEmail = (email: string): boolean => {
  // Reject empty string, or strings longer than 256 characters
  if (!email || typeof email !== 'string' || email.trim() === '' || email.length > 256)
    return false;

  const regex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  return regex.test(email);
};
